// Angular + External
import { Injectable, Directive, Inject } from "@angular/core";

import { Router } from "@angular/router";
// BFX
import { BfxAuthService } from "../services/bfx-auth.service";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { NativeDesktopSupport } from "app/bfx-native-desktop/native-desktop-support";

@Directive()
@Injectable()
export class AuthGuard {
  constructor(private _router: Router, private _authService: BfxAuthService) {}

  canActivate(): boolean {
    if (module.hot) {
      return true;
    } else if (this._authService.isAuthenticated()) {
      return true;
    } else {
      logger.out.info(`${this.constructor.name}.canActivate()`);

      if (!NativeDesktopSupport.logout(this._router, true)) {
        this._router.navigate(["not-authorized"]);
      }
      return false;
    }
  }
}
